import { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import { WbBadge, WbBadgeProps } from '@agilelab/plugin-wb-platform';
import { PrototypeStatus } from '@agilelab/plugin-wb-system-prototype-common';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import LightbulbIcon from '@material-ui/icons/EmojiObjects';
import SearchIcon from '@material-ui/icons/Search';

export const STATUS_OPTIONS_MAP: Record<
  PrototypeStatus,
  { label: string; color: string; icon: JSX.Element }
> = {
  [PrototypeStatus.IDEA]: {
    label: 'Idea',
    color: '#eceff1',
    icon: <LightbulbIcon fontSize="small" />,
  },
  [PrototypeStatus.DISCOVERY]: {
    label: 'Discovery',
    color: '#ffe0b2',
    icon: <SearchIcon fontSize="small" />,
  },
  [PrototypeStatus.VALIDATED]: {
    label: 'Validated',
    color: '#b2ebf2',
    icon: <DoneAllIcon fontSize="small" />,
  },
  [PrototypeStatus.APPROVED]: {
    label: 'Approved',
    color: '#b2f0e6',
    icon: <CheckIcon fontSize="small" />,
  },
  [PrototypeStatus.REJECTED]: {
    label: 'Rejected',
    color: '#cfd8dc',
    icon: <CloseIcon fontSize="small" />,
  },
};

type PrototypeStatusBadgeProps = {
  status: PrototypeStatus;
} & WbBadgeProps;

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }),
  { name: 'PrototypeStatusBadge' },
);

export const PrototypeStatusBadge: FC<PrototypeStatusBadgeProps> = ({
  className,
  style,
  status,
  ...props
}) => {
  const classes = useStyles();

  const statusOption = STATUS_OPTIONS_MAP[status];
  return (
    <WbBadge
      className={clsx(classes.root, className)}
      style={{ backgroundColor: statusOption.color, ...style }}
      {...props}
    >
      {statusOption.icon} {statusOption.label}
    </WbBadge>
  );
};
